<div style="display: grid; grid-template-columns: repeat(12, 1fr); gap: 16px; align-items: end;">

  <div class="flexColumn" style="gap: 4px; grid-column: 1 / span 10;">
    <span [style.opacity]="disabled ? '0.5' : '1'">{{ 'REGISTRY.VIRTUAL_METRICS.SCHEDULE_EVERY' | translate }}</span>

    <app-cron-selector
      *ngIf="enableAdvancedCronSelection"
      [value]="value"
      (cronChange)="onAdvancedChange($event)"
      [style.pointer-events]="disabled ? 'none' : 'auto'"
      [style.opacity]="disabled ? '0.5' : '1'">
    </app-cron-selector>

    <dx-select-box
      *ngIf="!enableAdvancedCronSelection"
      [value]="value"
      (onValueChanged)="onSimpleChange($event.value)"
      [dataSource]="simpleCronSelectionOptions"
      [disabled]="disabled"
      [displayExpr]="translateSimpleCron"
      [valueExpr]="'value'">
    </dx-select-box>
  </div>

  <div *ngIf="!disabled" class="cronToggleColumn" style="grid-column: 11 / span 2;">
    <div>{{ 'REGISTRY.VIRTUAL_METRICS.ADVANCED_CRON' | translate }}</div>
    <dx-switch
      [(value)]="enableAdvancedCronSelection"
      (valueChange)="onModeToggle($event)">
    </dx-switch>
  </div>

</div>
